<template>
  <v-container v-if="reportDetail">
    <!--  -->
    <GoBackAtTop
      :to="{
        name: 'InstructorApprenticesReport',
        params: { bookId: bookId, reportId: reportId },
      }"
      :label="$t('ebook.report')"
    />

    <template v-if="reportDetail.subElement">
      <div class="title-icon">
        <h1>{{ reportDetail.subElement.element.name }}</h1>
        <v-btn
          icon
          :href="links.ebook.instructorInfo"
          target="_blank"
        >
          <v-icon>$sl-question</v-icon>
        </v-btn>
      </div>
      <h5>{{ reportDetail.subElement.name }}</h5>
      <p>{{ reportDetail.subElement.description }}</p>

      <ActionButton
        actionIcon="$sl-hammer"
        class="mt-6"
        :isDisabled="!edit || !isApprenticeInstructor || isImitatingUser()"
        type="application"
        @click="changeElementClick(reportDetail)"
        >{{ $t("ebook.element-change") }}</ActionButton
      >
    </template>

    <v-dialog persistent v-model="changeElementModal" max-width="700px">
      <EbookElementModalChangeElement
        :elements="elements"
        @close="changeElementModalClose()"
        @updatedElement="closeAndUpdated()"
        :reportDetail="selectedElement"
      ></EbookElementModalChangeElement>
    </v-dialog>

    <v-divider class="my-5 fullwidth"></v-divider>

    <!-- Apprentice STARTS HERE -->
    <div v-if="reportDetail && reportDetail.subElement">
      <h6 v-if="apprentice">
        {{ apprentice.firstName }} {{ $t("ebook.qualification-subtitle2") }}
      </h6>
      <KnowledgeBoxes
        :isInstructor="false"
        :radiobuttons="false"
        :elem="reportDetail"
        @knowledgeClick="knowledgeResultInstructorApprentice"
      ></KnowledgeBoxes>

      <!-- <v-textarea
        v-if="reportDetail"
        rows="2"
        auto-grow
        disabled
        :value="reportDetail.apprenticeComment"
        :label="apprenticeTextareaLabel"
        type="text"
        class="mt-9"
      ></v-textarea>-->

      <h6 class="mt-6 mb-2">
        {{ apprentice.firstName | filterGenitiveName }} {{ $t("ebook.comment") }}
      </h6>
      <p>{{ reportDetail.apprenticeComment || $t("ebook.no-comments") }}</p>
    </div>
    <!-- Apprentice Ends HERE -->
    <v-divider class="my-6 fullwidth"></v-divider>
    <!-- instructorSkillEstimatedLevel STARTS HERE -->
    <div v-if="reportDetail && reportDetail.subElement">
      <h6 v-if="apprentice">
        {{ $t("ebook.qualification-subtitle") }} {{ apprentice.firstName }}
        {{ $t("ebook.qualification-subtitle-2") }}
      </h6>
      <KnowledgeBoxes
        :isInstructor="!!isApprenticeInstructor"
        :radiobuttons="!!isApprenticeInstructor"
        :elem="reportDetail"
        @knowledgeClick="knowledgeClick"
        @emitInstructorSkillEstimatedLevelWithoutClicking="
          emitInstructorSkillEstimatedLevelWithoutClicking
        "
      ></KnowledgeBoxes>

      <v-row class="mt-6 mb-6">
        <v-col class="pt-0 pb-0 d-flex align-center flex-wrap">
          <v-icon left>$sl-completed</v-icon>
          <p class="mb-0 text-body-2 text-caption">{{ $t('ebookReportElementsModal.icon-explanation-text-4', {
            studentName: `${ get(apprentice, 'firstName', '') } ${ get(apprentice, 'lastName', '')}`
          }) }}</p>
        </v-col>
      </v-row>

      <MessageBox class="mb-7" type="info" :closable="!!isApprenticeInstructor">
        <h6 class="pb-4 title text-uppercase">
          {{ $t("ebook.qualification-message-title") }}
        </h6>
        <p>{{ $t("ebook.qualification-message-text") }}</p>
        <p>{{ $t("ebook.qualification-message-text2") }}</p>
        <p>
          <a
            href="https://www.byggbranschensyrkesnamnd.se/guide/foretag-bedomning-och-godkannande-av-larlingens-rapport-via-mina-sidor/"
            target="_blank"
            >{{ $t("ebook.qualification-message-link") }}</a
          >
        </p>
      </MessageBox>

      <div v-if="reportDetail">
        <h6>{{ $t("ebook.your-comment") }}</h6>
        <v-textarea
          outlined
          auto-grow
          v-model="reportDetail.instructorComment"
          type="text"
          :disabled="!edit || !isApprenticeInstructor"
          class="mt-2"
          rows="3"
          row-height="30"
          textarea
          persistent-hint
        ></v-textarea>
      </div>
    </div>

    <!-- Error info starts here -->
    <MessageBox class="mb-7 mt-5" type="info" v-if="apprentice && diffAssessment">
      <h6 class="pb-4 title text-uppercase">{{ $t("ebook.messagebox-title") }}</h6>
      <p>{{ $t("ebook.messagebox-text") }}</p>
    </MessageBox>

    <!-- ACTION Buttons start here -->

    <ActionButton
      class="mt-6"
      @click="saveFunc"
      :isDisabled="judgementId < 0 || !edit || !isApprenticeInstructor || isImitatingUser()"
      actionIcon="$sl-save"
      >{{ $t("labels.save-element") }}</ActionButton
    >
    <ActionButton
      actionIcon="$sl-delete"
      class="mt-6"
      :isDisabled="!edit || !isApprenticeInstructor || isImitatingUser()"
      @click="deleteFunc"
      type="application"
      >{{ $t("labels.delete-element") }}</ActionButton
    >
    <ActionButton
      actionIcon="$sl-cancel"
      class="mt-6"
      @click="cancelFunc"
      type="application"
      >{{ $t("labels.cancel") }}</ActionButton
    >
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import API from "@/services/api.js";
import MessageBox from "@/components/Common/MessageBox";
import EbookElementModalChangeElement from "@/components/Ebook/Apprentice/EbookElementModalChangeElement";
import ActionButton from "@/components/Common/ActionButton";
import KnowledgeBoxes from "@/components/Common/Ebook/KnowledgeBoxes";
import GoBackAtTop from "@/components/Common/GoBackAtTop";
import get from 'lodash/get'

const SugarDate = require("sugar/date");
// @group Ebook
// Styled ReportDetail component
export default {
  name: "ReportDetail",

  components: {
    ActionButton,
    KnowledgeBoxes,
    EbookElementModalChangeElement,
    GoBackAtTop,
    MessageBox,
  },

  data: () => ({
    links: require('../../../lib/external-links.json'),
    apprentice: {},
    reportDetail: {},
    judgeComment: "",
    changeElementModal: false,
    elements: [],
    selectedElement: {},
    judgementId: null,
    instructorSkillEstimatedLevelClone: null,
    InstructorSkillEstimatedLevelWithoutClicking: null,
    triggerWatch: false,
    edit: false,
    bookId: -1,
    reportId: -1,
    reportDetailId: -1,
    reportInstructor: {}
  }),

  watch: {
    $route() {
      this.init();
    },
    triggerWatch() {
      this.init();
    },
  },
  created() {
    this.init();
  },
  filters: {
    filterGenitiveName(name) {
      if (name && name.length > 0) {
        if (name.slice(-1) == "s") return name;
      }
      return name + "s";
    },
  },
  computed: {
    ...mapGetters("currentuser", ["currentUser", "isInstructor", "isImitatingUser"]),
    isApprenticeInstructor() {
      if(this.reportInstructor) 
        return this.currentUser.employments.some(emp => emp.personId === this.reportInstructor.personId)
    },
    // @vuese
    // check if at least one of  apprenticeshipSkillEstimatedLevel &&  instructorSkillEstimatedLevel is diferent and display the error message
    diffAssessment() {
      if (!this.reportDetail) return;
      let checkDiff = false;

      if (
        this.reportDetail.apprenticeshipSkillEstimatedLevel &&
        this.reportDetail.instructorSkillEstimatedLevel &&
        this.reportDetail.apprenticeshipSkillEstimatedLevel !=
          this.reportDetail.instructorSkillEstimatedLevel
      ) {
        checkDiff = true;
      }

      return checkDiff;
    },
  },

  methods: {

    get,
    
    init() {      
      if (this.$route.params && this.$route.params.bookId) {
        this.bookId = this.$route.params.bookId;
      }
      if (this.$route.params && this.$route.params.reportId) {
        this.reportId = this.$route.params.reportId;
      }
      if (this.$route.params && this.$route.params.reportDetailId) {
        this.reportDetailId = this.$route.params.reportDetailId;
      }
      if (this.currentUser && this.isInstructor(0) == true && this.$route.params) {
        this.getBookById();
      }
    },
    closeAndUpdated() {
      this.changeElementModal = false;
      this.getReportDetailsByDetailsId();
    },
    changeElementModalClose() {
      this.changeElementModal = false;
    },
    changeElementClick(element) {
      this.selectedElement = element;
      this.changeElementModal = true;
    },
    // @vuese
    // Used get report by id
    // @arg The argument is an integer representing book and report id
    getReportById() {
      API.getReport(this.bookId, this.reportId)
        .then((res) => {
          this.report = res.data;      
          this.reportInstructor = res.data.instructor    

          if (
            !this.report.status ||
            this.report.status == "" ||
            this.report.status == "draft" ||
            this.report.status == "notCertified"
          ) {
            this.edit = true;
          }
        })
        .catch((error) => {
          console.log("There was an error:", error.response);
        });
    },
    // @vuese
    // Used to get report detail by detail id
    // @arg The arguments are integers representing book id ,report id, report detail id
    getReportDetailsByDetailsId() {      
      if (!this.bookId || !this.reportId || !this.reportDetailId) return;
      API.getReportDetail(this.bookId, this.reportId, this.reportDetailId)
        .then((response) => {
          this.reportDetail = response.data;          
          this.instructorSkillEstimatedLevelClone =
            response.data.instructorSkillEstimatedLevel;
        })
        .catch((error) => {
          console.log("Error " + error);
        });
    },
    // @vuese
    // Used to get book by id
    // @arg The argument is integer representing book id
    getBookById() {
      API.getBook(this.$route.params.bookId)
        .then((res) => {
          if (this.isInstructor(res.data.apprenticeship.companyId) == true) {
            this.bookId = this.$route.params.bookId;
            this.reportId = this.$route.params.reportId;
            this.reportDetailId = this.$route.params.reportDetailId;
            this.getReportDetailsByDetailsId();
            this.getReportById();
            this.apprentice = res.data.person;
            this.elements = res.data.bookElements;
          }
        })
        .catch((error) => {
          console.log("There was an error:", error.response);
        });
    },
    knowledgeClick(id) {
      this.judgementId = id;
      this.reportDetail.instructorSkillEstimatedLevel = id;
    },
    emitInstructorSkillEstimatedLevelWithoutClicking(id) {
      this.InstructorSkillEstimatedLevelWithoutClicking = id;
    },
    knowledgeResultInstructorApprentice(newval) {},
    // @vuese
    // Used to update report datail
    // @arg The arguments are integers representing book id ,report id, report detail id
    saveFunc() {
      let params = {};
      if (this.judgementId > 0) {
        params = {
          instructorSkillEstimatedLevel: this.judgementId,
          instructorComment: this.reportDetail.instructorComment,
        };
      } else {
        params = {
          instructorSkillEstimatedLevel: this
            .InstructorSkillEstimatedLevelWithoutClicking,
          instructorComment: this.reportDetail.instructorComment,
        };
      }

      API.updateReportDetail(this.bookId, this.reportId, this.reportDetailId, {
        data: params,
      })
        .then((response) => {
          this.triggerWatch = !this.triggerWatch;
          this.$t("success.saved");
          this.$nextTick(() => {
            this.$router.push({
              name: "InstructorApprenticesReport",
              params: { bookId: this.bookId, reportId: this.reportId },
            });
          });
        })
        .catch((error) => {
          console.log(params + "Error: " + error);
        });
    },
    // @vuese
    // Used to delete report datail
    // @arg The arguments are integers representing book id ,report id, report detail id
    deleteFunc() {
      API.deleteReportDetail(this.bookId, this.reportId, this.reportDetailId)
        .then((response) => {
          this.$events.fire("showInfo", this.$t("success.saved"));
          this.triggerWatch = !this.triggerWatch;
          this.$nextTick(() => {
            this.$router.push({
              name: "InstructorApprenticesReport",
              params: { bookId: this.bookId, reportId: this.reportId },
            });
          });
        })
        .catch((error) => {
          console.log(params + "Error: " + error);
        });
    },
    cancelFunc() {
      this.triggerWatch = !this.triggerWatch;
      this.$nextTick(() => {
        this.$router.push({
          name: "InstructorApprenticesReport",
          params: { bookId: this.bookId, reportId: this.reportId },
        });
      });
    },
  },
};
</script>
